module.exports = __webpack_public_path__ + "img/retrofit-3.a6844b46.png";